Lesson     = require '../../../models/lesson'

start_time = null

open    = ->
  start_time = Date.now()

  lesson = new Lesson()
  lesson.load (err, lessonData) ->
    initOptions = {
      preventLogoutOnExit: !!lessonData?.config?.preventLogoutOnExit
    }

    pipwerks.SCORM.init(initOptions)

padLeft = (val = "", length) ->
  str = ""
  vl  = val.toString().length
  if (vl >= length)
    val
  else
    l = length - vl + 1
    (new Array(l).join("0")).substr(0, (length - vl)) + val

setSessionTime = ->
  end_time     = Date.now()
  session_time = Math.floor((end_time - start_time) / 1000)
  hours        = Math.floor(session_time / 3600)
  minutes      = Math.floor((session_time - hours * 3600) / 60)
  seconds      = session_time - hours * 3600 + minutes * 60
  session_time = [ padLeft(hours, 4),
                   padLeft(minutes, 2),
                   padLeft(seconds, 2) ].join(":")

  pipwerks.SCORM.set("cmi.core.session_time", session_time)

complete = ->
  setSessionTime()
  lesson = new Lesson()
  lesson.load (err, lessonData) ->
    if lessonData
      { minimumScore, incompleteOnFail } = lessonData.config or {}
      Application.actions("Analytics")
        .trackScoreAndCompletion(minimumScore, incompleteOnFail)
    else
      console.error "Error loading lesson data", err
    
    # If SCORM.quit() is called, the lesson exits even when the exit Button is enabled
    if lessonData.config.hasScormExitButton
      pipwerks.SCORM.save()
    else
      pipwerks.SCORM.quit()

exit = ->
  setSessionTime()
  pipwerks.SCORM.quit()

commands  = (next) -> { complete, open, exit }

module.exports = { type: "lesson", commands }
